/**
 * After an Auth0 login, shows the page the login started from (appState.returnTo). The
 * SDK's default only rewrites the address, and BrowserRouter follows only its own
 * navigations and popstate, so it kept showing Monitor under the other page's address.
 */
export function onRedirectCallback(appState) {
  const returnTo = appState?.returnTo || window.location.pathname;
  window.history.replaceState(window.history.state, document.title, returnTo);
  window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
}
